import React from 'react';
import { getHiddenTicket } from '../../../data/utils/getHiddenTicket';
import { getBarcode } from '../../../data/utils/getBarcode';
import { getCurrencySymbol } from '../../../data/utils/getCurrencySymbol';
import { getLabel } from '../../../data/labels';

function IsibetHorseTicketFooter(props) {
	
	const ticketData = props.ticketData;
	const conf = props.conf;
	const frontendType = props.frontendType;
	const aamsEnviroment = props.aamsEnviroment; // TODO: add "isEstero" in configuration if "nationsAsSkin" wont be enough. In Italy no way to have two different currencies at the moment ;)
	const printAgainTerminalRec = props.printAgainTerminalRec;
	let printableTotalAmount = ticketData.price + "";
	let printableWinning = ticketData.maxWon;
	
	if(printableTotalAmount.indexOf(' ') >= 0){
		const values = printableTotalAmount.split(' ');
		if(values.length === 2){
			printableTotalAmount = getCurrencySymbol(props.conf.cs.ct) + ' ' + values[1];
		}
	}
	
	if(printableWinning){
		printableWinning = printableWinning + "";
		if(printableWinning.indexOf(' ') >= 0){
			const values = printableWinning.split(' ');
			if(values.length === 2){
				printableWinning = getCurrencySymbol(props.conf.cs.ct) + ' ' + values[1];
			}
		}
	}
	
	const terminalCopy = props.terminalCopy;
	const skinProperties = props.skinProperties;

	const clearBoth = {clear: "both"};
	
	
	let idTicketToShow = ticketData.idTicket;
	if(terminalCopy && skinProperties && skinProperties.hideTerminalTicket){
		idTicketToShow = getHiddenTicket(idTicketToShow);
	}
	
	
	function generateIdTicketWithBars(idTicket){
		let res = '';
		let tokens = idTicket.match(/.{1,4}/g);
		res = tokens.join("-");
		return res;
	}

	
	// this char will be added to the string "ID" (it means identify string of the ticket) to make clear that this receipt has been
	// print again due to technical issues.
	let charPAR = '';
	if(printAgainTerminalRec){
		let idString = getLabel('printer.plain_ticket.header.id');
		idString = (idString == null || idString === '')? 'IB' : idString;
		charPAR = idString.charAt(idString.length - 1);	
	}
	
	
	//let totalAmountLabel = getLabel('printer.plain_ticket.footer.total_amount');;
	

	let numCombDiscl = ticketData.totalCombinations;
	if(numCombDiscl){
		numCombDiscl = numCombDiscl + "";
		while(numCombDiscl.length < 5){
			numCombDiscl = "0" + numCombDiscl;
		}
	}
	
	
	return <>
		<div className='separator'></div>
		<div className="bold">
			{ numCombDiscl && <div className="left td-60">NS-{numCombDiscl}</div> }
			<div className="right td-40 textright">{"IMPORTO " + printableTotalAmount}</div>
			<div style={clearBoth}></div>
		</div>


		{
			printableWinning && <>
			<div className="textcenter total_win_text">{getLabel('printer.plain_ticket.footer.total_winnings')}</div>
			<div className="textcenter total_win">{printableWinning}</div>
			</>
			
		}

		<div className="textcenter id_ticket_footer">{getLabel('printer.plain_ticket.header.id') + charPAR}: {generateIdTicketWithBars(idTicketToShow)}</div>			

		<div className="barcode-top"> 
			<img style={{ height: "50px", width:"100%"}} src={getBarcode(ticketData.idTicket, 1, false)} />
		</div>
		
		<div className="separator"></div>
		{
			props.terminalCopy && <>
				<div className="center disclaimer_spacing website">{conf.url}</div>			
				{
					aamsEnviroment &&(
							<div className="center disclaimer_spacing bold">
								La registrazione e l'esito della puntata effettuata possono essere verificati sul sito www.aams.it.
								<br/>
								Questo promemoria non è una ricevuta di gioco valida per la riscossione della vincita.
							</div>
					)
				}
			</>
		}
		<div className="center disclaimer_spacing bold">
		Il gioco può causare dipendenza.
		<br/>
		Consulta le probabilità di vincita su www.aams.gov.it
		<br/>
		E' vietato il gioco ai minori di anni 18
		</div>
		{/* ****************************************************************************************************************************************   
			On environments where the payment of ticket can be done on physical self (conf.rs.paysc is true ), the imprinter needs enough whitespace at the bottom of the printed ticket.
			IMPORTANT: to ensure that a whitespace is rendered on the bottom edge, this content should always be placed at the end of this component.
			To make sure that the whitespace is printend when calling window.print(), we render a <div> containing a '.' with a font size of 1px 
		*/
			conf?.rs?.paysc && <div style={{ marginTop : "35px", fontSize: "1px"}}>.</div>
		}

		
	</>
}

export default IsibetHorseTicketFooter;